module.exports = __webpack_public_path__ + "fa-brands-400.eot";


//////////////////
// WEBPACK FOOTER
// ./~/@fortawesome/fontawesome-free/webfonts/fa-brands-400.eot
// module id = 3
// module chunks = 0